import { render, staticRenderFns } from "./InfinityPopover.vue?vue&type=template&id=55441868&"
import script from "./InfinityPopover.vue?vue&type=script&lang=ts&"
export * from "./InfinityPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-shared/mfe-shared/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55441868')) {
      api.createRecord('55441868', component.options)
    } else {
      api.reload('55441868', component.options)
    }
    module.hot.accept("./InfinityPopover.vue?vue&type=template&id=55441868&", function () {
      api.rerender('55441868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/InfinityPopover.vue"
export default component.exports